module.exports = __webpack_public_path__ + "img/herohire-logo.27c64605.png";